export const SITE_NAME = 'Dragon Help';
export const SITE_DOMAIN = 'dragonhelps.com';
export const SITE_URL = 'https://www.dragonhelps.com';
export const SITE_TAGLINE = 'Expert Dragon NaturallySpeaking Support';
export const COMPANY_NAME = 'Nodex Global LLC';
